<div class="row">
    <div class="col-12 col-md-3">
        <div class="card rounded-0" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Bank</h3>
                    <div class="mb-3">
                        <label for="title" class="form-label">Title <em>*</em></label>
                        <input type="text" class="form-control" id="title" name="title" #title="ngModel" [(ngModel)]="data.title" required>
                        <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
                            <div *ngIf="title.errors.required">Title is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="show_at_app" class="form-label">Show at App <em>*</em></label>
                        <select class="form-control" name="show_at_app" #show_at_app="ngModel" [(ngModel)]="data.show_at_app" required>
                            <option [value]="1">Show</option>
                            <option [value]="0">Do Not Show</option>
                        </select>
                        <div *ngIf="f.submitted && show_at_app.invalid" class="invalid-feedback">
                            <div *ngIf="show_at_app.errors.required">Show at app is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Usage</label>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="use_deposit" name="use_deposit" [(ngModel)]="data.use_deposit">
                            <label class="form-check-label" for="use_deposit">Deposit</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="use_withdraw" name="use_withdraw" [(ngModel)]="data.use_withdraw">
                            <label class="form-check-label" for="use_withdraw">Withdraw</label>
                        </div>
                        <small class="text-muted">Leave both unchecked to allow this bank in both Deposit and Withdraw. Tick one to restrict it to that section only.</small>
                    </div>
                    <hr/>
                    <div class="mb-3">
                        <label for="payee" class="form-label">Payee Name</label>
                        <input type="text" class="form-control" id="payee" name="payee" #payee="ngModel" [(ngModel)]="data.payee" autocomplete="off">
                    </div>
                    <div class="mb-3">
                        <label for="account" class="form-label">Account Number</label>
                        <input type="number" class="form-control" id="account" name="account" #account="ngModel" [(ngModel)]="data.account" autocomplete="off">
                    </div>
                    <hr/>
                    <div class="mb-3" *ngIf="!data.uuid">
                        <label for="opening" class="form-label">Opening Balance</label>
                        <input type="number" class="form-control" id="opening" name="opening" #opening="ngModel" [(ngModel)]="data.opening" autocomplete="off">
                    </div>
                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
